module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": "inventory"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'Inventory',
      "path": '/inventory'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.rows.length === 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n              You don't currently have any inventory added. Please click add inventory to get started.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.addInventory()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Inventory\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.rows.length !== 0),
      expression: "!loading && rows.length !== 0"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card data-tables"
  }, [_c('div', {
    staticClass: "\n                  card-body\n                  table-no-bordered\n                  dataTable\n                  dtr-inline\n                  table-full-width\n                "
  }, [_c('div', {
    staticClass: "toolbar text-right",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.addInventory()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Add Inventory\n                  ")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), (!_vm.loading && _vm.rows.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.addInventory()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Add Inventory\n            ")])])]) : _vm._e()])]), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fresh-datatables"
  }, [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables_inventory",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Internal ID")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Rollup Description")]), _vm._v(" "), _c('th', [_vm._v("HTS Code")]), _vm._v(" "), _c('th', [_vm._v("Product Code")]), _vm._v(" "), _c('th', [_vm._v("FDA")]), _vm._v(" "), _c('th', [_vm._v("Num Per Case")]), _vm._v(" "), _c('th', [_vm._v("Price Per Unit")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Actions")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c88bc8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventory/view.vue
// module id = 758
// module chunks = 0